import { DateTime } from "luxon";

export default function formatValue(value, type) {

    let dt = null;

    switch (type) {
        case 'date':
            dt = DateTime.fromISO(value);
            return dt?.isValid ? `${dt.toLocaleString(DateTime.DATE_FULL)} (${dt.toRelative()})` : 'No Date Selected';
        case 'time':
            dt = DateTime.fromISO(value);
            return dt?.isValid ? dt.toLocaleString(DateTime.TIME_SIMPLE) : 'No Time Selected';
        case 'datetime':
            dt = DateTime.fromISO(value)
            return dt?.isValid ? dt.toLocaleString(DateTime.DATETIME_MED) : 'No Date Selected';
        default: return value;
    }

}
